module.exports = __webpack_public_path__ + "img/xlw.6a6f385d.jpg";